<!-- src/lib/components/shared/SEOHead.svelte -->
<script lang="ts">
	export let title: string;
	export let description: string;
	export let canonical: string = '';
	export let ogImage: string = '/myth-map.png';
	export let ogImageAlt: string = 'Tiny Tribe Adventures';
	export let type: 'website' | 'article' = 'website';
	export let keywords: string = '';
	export let author: string = 'Tiny Tribe Adventures';
	export let publishedTime: string = '';
	export let modifiedTime: string = '';
	export let structuredData: object | null = null;
	export let noIndex: boolean = false;

	// Base URL
	const baseUrl = 'https://tinytribeadventures.com';

	// Ensure absolute URLs
	$: absoluteCanonical = canonical
		? canonical.startsWith('http')
			? canonical
			: `${baseUrl}${canonical}`
		: '';
	$: absoluteOgImage = ogImage.startsWith('http') ? ogImage : `${baseUrl}${ogImage}`;

	// Clean title for page title
	$: pageTitle = title.includes('Tiny Tribe Adventures')
		? title
		: `${title} | Tiny Tribe Adventures`;

	// Unfinished pages should stay out of search results without becoming dead
	// ends in the internal link graph. `follow` lets crawlers continue to the
	// finished guides and directory pages linked from a noindex page.
	$: robotsContent = noIndex ? 'noindex, follow' : 'index, follow';
	$: structuredDataScript = structuredData
		? `<script type="application/ld+json">${JSON.stringify(structuredData)}<` + '/script>'
		: '';
</script>

<svelte:head>
	<!-- Primary Meta Tags -->
	<title>{pageTitle}</title>
	<meta name="description" content={description} />
	{#if keywords}
		<meta name="keywords" content={keywords} />
	{/if}
	<meta name="author" content={author} />
	<meta name="robots" content={robotsContent} />

	<!-- Canonical URL -->
	{#if absoluteCanonical}
		<link rel="canonical" href={absoluteCanonical} />
	{/if}

	<!-- Open Graph / Facebook -->
	<meta property="og:type" content={type} />
	<meta property="og:title" content={title} />
	<meta property="og:description" content={description} />
	<meta property="og:image" content={absoluteOgImage} />
	<meta property="og:image:alt" content={ogImageAlt} />
	<meta property="og:site_name" content="Tiny Tribe Adventures" />
	<meta property="og:locale" content="en_US" />
	{#if absoluteCanonical}
		<meta property="og:url" content={absoluteCanonical} />
	{/if}
	{#if publishedTime}
		<meta property="article:published_time" content={publishedTime} />
	{/if}
	{#if modifiedTime}
		<meta property="article:modified_time" content={modifiedTime} />
	{/if}

	<!-- Twitter -->
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:title" content={title} />
	<meta name="twitter:description" content={description} />
	<meta name="twitter:image" content={absoluteOgImage} />
	<meta name="twitter:image:alt" content={ogImageAlt} />

	<!-- Additional Meta Tags -->
	<meta name="theme-color" content="#014421" />
	<meta name="msapplication-TileColor" content="#014421" />
	<meta name="apple-mobile-web-app-capable" content="yes" />
	<meta name="apple-mobile-web-app-status-bar-style" content="default" />
	<meta name="apple-mobile-web-app-title" content="Tiny Tribe Adventures" />

	<!-- Structured Data -->
	{#if structuredData}
		<!-- eslint-disable-next-line svelte/no-at-html-tags -->
		{@html structuredDataScript}
	{/if}
</svelte:head>
